package ui.campaign.detailv2.editor.wrapper

import common.frontend.api.Io
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus
import org.ssoft.common.type.ScreenRatio
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail_editor__err_location_no_devices_validation
import theme.ColorMaterialBlue500
import tk.mallumo.utils.noDiacriticsLower
import tools.EFieldList
import tools.EFieldRegularBoolean
import tools.await
import ui.campaign.detailv2.editor.feature.FeatureCounter
import ui.campaign.detailv2.editor.feature.FeatureCounter.LocationTimeOH

class CampaignWrapperELocation(
    val data: Io.Campaign,
    val counter: FeatureCounter,
) : ImplCampaignWrapperE {

    fun selectedScreenRatios(): List<ScreenRatio> {
        return locations.state.map { it.devices.state.filter { it.active.state }.map { it.data.screenRatio } }
            .flatten()
            .distinctBy { it }
            .map { ScreenRatio[it] }
    }

    fun unselectOverflowDevices() {
        locations.state.forEach { location ->
            location.devices.state.forEach { device ->
                if (device.active.state && device.countUsableDays <= 0) {
                    device.active.set(false)
                }
            }
        }
    }

    fun trimDaysExclusion(start: LocalDate, end: LocalDate) {
        var current = start
        val campaignDoy = mutableSetOf<Int>()
        while (current <= end) {
            campaignDoy.add(current.dayOfYear)
            current = current.plus(DatePeriod(days = 1))
        }
        locations.state
            .map { it.devices.state }
            .flatten()
            .filter { it.active.state }
            .forEach { device ->
                device.setExcludedDays(device.data.excludedDoY.filter { it in campaignDoy })
            }
    }

    override val err: Boolean
        get() = locations.state.none { it.devices.state.any { it.active.state } }

    override suspend fun extractErr(): String? {
        return if (!err) null
        else Res.string.layer_top_detail_editor__err_location_no_devices_validation.await()
    }

    val locations = AdapterLocation(data)

    class AdapterLocation(
        data: Io.Campaign,
    ) : EFieldList<Io.Campaign.LocationItem, AdapterLocation.Item>(
        items = data.locations.apply {
            sortBy { it.name.noDiacriticsLower }
            removeAll { it.devices.isEmpty() }
        },
        onBindEntry = {
            Item(it)
        }
    ) {



        class Item(
            override val data: Io.Campaign.LocationItem,
            override val key: String = data.id.toString(),
        ) : Entry<Io.Campaign.LocationItem> {
            val devices = AdapterDevice(data)
            var ohSpecs = LocationTimeOH(data.id)
        }
    }

    class AdapterDevice(
        data: Io.Campaign.LocationItem
    ) : EFieldList<Io.Campaign.DeviceItem, AdapterDevice.Item>(
        items = data.devices.apply {
            sortBy { it.name.noDiacriticsLower }
        },

        onBindEntry = {
            Item(it)
        },
    ) {

        class Item(
            override val data: Io.Campaign.DeviceItem,
            override val key: String = data.id.toString(),
        ) : Entry<Io.Campaign.DeviceItem> {

            val changed: Boolean get() = active.change

            val active = EFieldRegularBoolean(
                property = data::isActive
            )

            var usageByDoy: MutableMap<Int, FeatureCounter.DayInfo> = mutableMapOf()

            // dni v ktorych sa neda prehravat
            fun setExcludedDays(exDays: List<Int>) {
                data.excludedDoY = exDays
            }


            var maxUsageFutureColor = ColorMaterialBlue500
                private set


            var usageNow = 0F
            var impressionSum = 0L

            /**
             * Max usage after campaign apply
             */
            var maxUsageFuture = 0F
                set(value) {
                    field = value
                    maxUsageFutureColor = FeatureCounter.computeColor(value)
                }

            var countAllDays = 0
            var countUsableDays = 0
            var countNotUsableDays = 0

            /**
             * Campaign goals accomplishment
             */
            var goalAccomplishment = 0F

        }


    }
}